import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { documentationNav } from '../content';

interface DocPaginationProps {
  currentPageId: string;
}

export function DocPagination({ currentPageId }: DocPaginationProps) {
  // Find current page index
  const currentIndex = documentationNav.findIndex(page => page.id === currentPageId);

  // Get prev and next pages
  const prevPage = currentIndex > 0 ? documentationNav[currentIndex - 1] : null;
  const nextPage = currentIndex < documentationNav.length - 1 ? documentationNav[currentIndex + 1] : null;

  // If no prev or next, don't render
  if (!prevPage && !nextPage) return null;

  return (
    <nav aria-label="Documentation pagination" className="mt-12 border-t border-gray-200 pt-8">
      <div className="grid gap-4 md:grid-cols-2">
        {/* Previous page */}
        {prevPage ? (
          <Link
            to={prevPage.path ? `/documentation/${prevPage.path}` : '/documentation'}
            className="flex items-start gap-3 rounded-2xl border border-[#D4E2F4] bg-[#F9FAFB] p-4 transition hover:border-[#A6C7E9] hover:bg-[#F4F7FC] hover:shadow-sm"
          >
            <ArrowLeft size={20} className="mt-1 flex-shrink-0 text-[#4A97AC]" aria-hidden="true" />
            <div className="min-w-0 flex-1">
              <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Previous</p>
              <p className="mt-1 text-sm font-semibold text-sb-black">{prevPage.title}</p>
              <p className="mt-1 text-xs text-gray-600">{prevPage.description}</p>
            </div>
          </Link>
        ) : (
          <div aria-hidden="true" />
        )}

        {/* Next page */}
        {nextPage ? (
          <Link
            to={nextPage.path ? `/documentation/${nextPage.path}` : '/documentation'}
            className="flex items-start gap-3 rounded-2xl border border-[#D4E2F4] bg-[#F9FAFB] p-4 transition hover:border-[#A6C7E9] hover:bg-[#F4F7FC] hover:shadow-sm md:text-right"
          >
            <div className="min-w-0 flex-1">
              <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Next</p>
              <p className="mt-1 text-sm font-semibold text-sb-black">{nextPage.title}</p>
              <p className="mt-1 text-xs text-gray-600">{nextPage.description}</p>
            </div>
            <ArrowRight size={20} className="mt-1 flex-shrink-0 text-[#4A97AC]" aria-hidden="true" />
          </Link>
        ) : (
          <div aria-hidden="true" />
        )}
      </div>
    </nav>
  );
}
